import i18n from "@/i18n";
import { BaseRequisitesVue } from "./BaseRequisitesVue"

/**
 *  Класс для компоненты реквизитов.
 */
export class RequisitesVue extends BaseRequisitesVue {
  
  /** реквизиты счета */
  get details(): Array<any> {
    let bankDetails: Array<any> = [];
    if (this.bankDetails) {
      const contract = this.contractsStore.contracts.getContract(this.id);
      if (contract.Data.CurrencyCharCode === 'RUR') {
        bankDetails = super.details;  
      } else {
        bankDetails = [
          {
            //Владелец Счета
            name: i18n.t("main.contracts.bankDetails.RecepientName"),
            textVal: this.bankDetails.RecepientName
          },
          {
            //Расчётный/Лицевой счёт
            name: i18n.t("main.contracts.bankDetails.Rs"),
            textVal: this.bankDetails.Rs
          },
          {
            //Банк получателя"
            name: i18n.t("main.contracts.bankDetails.BankName"),
            textVal: this.bankDetails.BankName
          },
          {
            name: i18n.t("main.contracts.bankDetails.SwiftBankName"),
            textVal: this.bankDetails.SwiftBankName
          },
          {
            name: i18n.t("main.contracts.bankDetails.KorrBankName"),
            isWrapped: true,
            textVal: this.bankDetails.KorrBankName
          },
          {
            name: i18n.t("main.contracts.bankDetails.SwiftKorrBankName"),
            textVal: this.bankDetails.SwiftKorrBankName
          }
        ];        
      }
    }
    return bankDetails;
  }
}
